import React, { useState } from 'react';
import { Form, Popover, Input, message, Button } from 'antd';
import { BaseService } from '@/service';
import { useWatchState } from '@/store';
import { checkResult } from '@/common';
import "./style.less";

const { TextArea } = Input

const App = Form.create({ name: 'register' })(({ className = "", form, itemId, itemType, userId, pushWechatId, pushGroupId, orgId, children }) => {

    const { getFieldDecorator } = form;

    const [[UPLOAD_SERVER_HOST = ""]] = useWatchState(["$_UPLOAD_SERVER_HOST"]);
    const [[user]] = useWatchState(["user"]);
    console.log(user);
    const [loading, setLoading] = useState(false);
    const [showForm, setShowForm] = useState(false);
    const [files, setFiles] = useState([]);

    const handleSubmit = (e) => {
        e.preventDefault();
        form.validateFieldsAndScroll(async (err, values) => {
            if (!err) {
                addFeedback(values);
            }
        });
    };

    const addFeedback = vo => {
        setLoading(true);
        BaseService.add({
            table: "thtt_feedback",
            data: {
                user_id: user.info.user_id,
                item_id: itemId,
                item_type: itemType,
                source: 2,
                ...vo,
                files: JSON.stringify(files),
                add_time: new Date().format("yyyy-MM-dd hh:mm:ss")
            }
        }).then(res => {
            setLoading(false);
            if (!checkResult(res)) return;
            message.success("您的反馈提交成功，我们会尽快与您联系！");
            form.setFieldsValue({
                phone: "",
                name: "",
                remark: "",
            })
            setFiles([]);
            setShowForm(false);
        }, err => setLoading(false))
    }

    const content = (
        <Form id="feedForm" className="com-feedback__form" onSubmit={handleSubmit}>
            <Form.Item label="联系方式">
                {getFieldDecorator('phone', {
                    rules: [
                        {
                            required: true,
                            message: '请输入联系方式！',
                        },
                    ],
                })(<Input placeholder="请输入联系方式" />)}
            </Form.Item>
            <Form.Item label="姓名">
                {getFieldDecorator('name', {
                    rules: [
                        {
                            required: true,
                            message: '请输入姓名！',
                        },
                    ],
                })(<Input placeholder="请输入姓名" />)}
            </Form.Item>
            <Form.Item label="反馈意见">
                {getFieldDecorator('remark', {
                    rules: [
                        {
                            required: true,
                            message: '请输入反馈意见！',
                        },
                    ],
                })(<TextArea rows={3} placeholder="请输入反馈意见" />)}
            </Form.Item>

            <Form.Item>
                <Button type="primary" htmlType="submit" loading={loading}>保存</Button>
            </Form.Item>
        </Form>
    )

    return (
        <div className={`com-feedbackDeal${showForm && "com-feedback--showForm"} ${className}`}>
            <Popover placement="left" title="反馈" content={content} trigger="click">
                {children}
            </Popover>
        </div>
    );
})

export default App;